export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_DATA = 'GET_USER_DATA';
export const GET_USER_ERROR = 'GET_USER_ERROR';

export const SET_USER_HISTORY_SORT_DATA = 'SET_USER_HISTORY_SORT_DATA';
export const SORTING_USER_HISTORY_ACTION = 'SORTING_USER_HISTORY_ACTION';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_DATA = 'CREATE_USER_DATA';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_DATA = 'DELETE_USER_DATA';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

// RESET PASSWORD
export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST';
export const RESET_USER_PASSWORD_DATA = 'RESET_USER_PASSWORD_DATA';
export const RESET_USER_PASSWORD_ERROR = 'RESET_USER_PASSWORD_ERROR';

// CHANGE USER PASSWORD
export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_DATA = 'CHANGE_USER_PASSWORD_DATA';
export const CHANGE_USER_PASSWORD_ERROR = 'CHANGE_USER_PASSWORD_ERROR';

// GET USER DETAILS Actions
export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_DATA = 'GET_USER_DETAILS_DATA';
export const GET_USER_DETAILS_ERROR = 'GET_USER_DETAILS_ERROR';
